import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import Card from "semantic-ui-react/dist/commonjs/views/Card";
import Image from "semantic-ui-react/dist/commonjs/elements/Image";
import React from "react";
import BusinessProfileModel from "models/business-profiles/BusinessProfile";
import { DropdownItemProps } from "semantic-ui-react/dist/commonjs/modules/Dropdown/DropdownItem";
import { PricingTranslations } from "i18n/containers/Pricing/typing";
import { PricingTexts } from "i18n/containers/Pricing";

import { ProductKeys } from "containers/Pricing/products";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";
import { filterBusinessProfilesByProductKey } from "containers/Pricing/card-plans/card-plans-checkout-modal/fields/filters";
import { useGetOneTimePurchasesFromBusinessProfiles } from "hooks/payments/useGetOneTimePurchasesFromBusinessProfiles";
import { mapBusinessProfileFromChallengeOneTimePurchase } from "containers/Pricing/card-plans/card-plans-checkout-modal/fields/mapBusinessProfileTo";
import { DropdownProps } from "semantic-ui-react/dist/commonjs/modules/Dropdown/Dropdown";
import Link from "next/link";
import { UserProfileContext } from "@context";
import {useLocales} from "@libs";

export const ListOfBusinessProfilesFieldForPayments = (props: {
	onSelectBusinessProfile: (businessProfile: BusinessProfileModel) => void;
	typeOfProduct: ProductKeys;
}) => {
	const { onSelectBusinessProfile, typeOfProduct } = props;
	const { currentShortLocale } = useLocales();
	const pricingTranslations: PricingTranslations = {
		...PricingTexts[currentShortLocale],
	};
	const [selectedBusinessProfile, setSelectedBusinessProfile] = React.useState<BusinessProfileModel | null>(null);
	const { businessProfiles } = React.useContext(UserProfileContext);
	const filteredBusinessProfiles = filterBusinessProfilesByProductKey(businessProfiles, typeOfProduct);
	const { isLoading: isGettingOneTimePurchasesLoading, oneTimePurchases } = useGetOneTimePurchasesFromBusinessProfiles(
		filteredBusinessProfiles.map((businessProfile) => Number(businessProfile.info.id)),
		"succeeded",
		ProductKeys.Challenges,
	);
	const handleOnChangeBusinessProfile = (event: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
		const fullBusinessProfile: BusinessProfileModel | undefined = businessProfiles.find(
			(businessProfile) => businessProfile.info.id === data.value,
		);

		if (fullBusinessProfile) {
			setSelectedBusinessProfile(fullBusinessProfile);
			onSelectBusinessProfile(fullBusinessProfile);
		}
	};

	const dropdownOptions: DropdownItemProps[] = filteredBusinessProfiles.map((businessProfile) => {
		return mapBusinessProfileFromChallengeOneTimePurchase(
			businessProfile,
			oneTimePurchases,
			pricingTranslations,
		) as DropdownItemProps;
	});

	const reloadPage = () => location.reload();

	return (
		<>
			<Dropdown
				fluid
				selection
				loading={isGettingOneTimePurchasesLoading}
				disabled={isGettingOneTimePurchasesLoading}
				options={dropdownOptions}
				placeholder={pricingTranslations.listOfBusinessProfiles}
				onChange={handleOnChangeBusinessProfile}
			/>
			<Grid
				columns={"equal"}
				className={"full-width margin-0-all"}
			>
				<Grid.Column>
					<Link
						href="/business-profile/new"
						passHref
					>
						<a target={"_blank"}>
							<Icon name={"user circle"} />
							{pricingTranslations.createNewBusinessProfile}
						</a>
					</Link>
				</Grid.Column>
				<Grid.Column textAlign={"right"}>
					<a
						className="font-color-white-grey"
						href="#"
						onClick={reloadPage}
					>
						<Icon name={"redo"} />
						{pricingTranslations.refresh}
					</a>
				</Grid.Column>
			</Grid>
			{selectedBusinessProfile && (
				<Card fluid>
					<Card.Content>
						<Image
							floated="right"
							size="mini"
							src={selectedBusinessProfile.info.avatar.src}
						/>
						<Card.Header>
							<a
								href={selectedBusinessProfile.info.url}
								target={"_blank"}
								rel="noreferrer"
							>
								{selectedBusinessProfile.info.fullName}
							</a>
						</Card.Header>
						<Card.Meta>{selectedBusinessProfile.info.emblem}</Card.Meta>
					</Card.Content>
				</Card>
			)}
		</>
	);
};
